/* eslint-disable max-lines-per-function */
import React from "react";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import { cn } from "tailwind-variants";
import "./ShirtMockup.scss";

export default function ShirtMockup({
  artworkUrl = remoteImageStaticUrl("gen/size-mockup/placeholder.png", {
    h: 100,
    dpr: 2
  }),
  selectedColor = "#E1E1E1",
  preset = "full-front",
  size = "small",
  ...restProps
}) {
  const PRESET_CONFIG = {
    "full-front": {
      bounds: {
        x: 40,
        y: 40,
        width: 35,
        height: 48
      }
    },
    "full-back": {
      bounds: {
        x: 43,
        y: 39,
        width: 35,
        height: 57
      }
    },
    "left-chest": {
      bounds: {
        x: 49,
        y: 30,
        width: 20,
        height: 20
      }
    },
    sleeve: {
      bounds: {
        x: 25,
        y: 33,
        width: 15,
        height: 14
      }
    },
    "back-collar": {
      bounds: {
        x: 43,
        y: 20,
        width: 20,
        height: 20
      }
    }
  };

  function isBack() {
    return preset === "full-back" || preset === "back-collar";
  }

  function isSleeve() {
    return preset === "sleeve";
  }

  function isCustom() {
    return preset === "custom";
  }

  function multiplier() {
    if (size === "large") return 2.2;
    if (size === "medium") return 1.88;
    return 1;
  }

  function imgSrc() {
    let side = "front";
    if (isBack()) side = "back";
    if (isSleeve()) side = "side";
    return remoteImageStaticUrl(`gen/size-mockup/${side}.png`, {
      h: 100,
      dpr: 2
    });
  }

  function presetBounds() {
    return PRESET_CONFIG[preset]?.bounds;
  }

  function boundsStyle() {
    const bounds = presetBounds();
    if (!bounds) return {};
    const topLeftX = bounds.x - bounds.width / 2;
    const topLeftY = bounds.y - bounds.height / 2;
    return {
      top: `${topLeftY * multiplier()}px`,
      left: `${topLeftX * multiplier()}px`,
      width: `${bounds.width * multiplier()}px`,
      height: `${bounds.height * multiplier()}px`
    };
  }

  return (
    <div
      {...restProps}
      className={cn("shirt-mockup scope-ee8f89f7", restProps?.className, `shirt-mockup--${size}`)}
    >
      <div
        className="shirt-mockup__item scope-ee8f89f7"
        style={{
          backgroundColor: selectedColor
        }}
      >
        <img
          className="shirt-mockup__item-image scope-ee8f89f7"
          src={imgSrc()}
          alt="Shirt Design"
          draggable={false}
        />

        <div className="shirt-mockup__bounds-box scope-ee8f89f7" style={boundsStyle()}>
          {artworkUrl && !isCustom() ? (
            <img
              className="shirt-mockup__artwork scope-ee8f89f7"
              src={artworkUrl}
              alt="Artwork"
              draggable={false}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
